import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import {
  Navigate,
  Outlet,
  RouterProvider,
  createHashRouter,
} from "react-router-dom";
import { SENTRY_DSN } from "./config";
import { loginRoutes } from "./login/route";
import { orderRoutes } from "./order/routes";
import { returnRoutes } from "./return/routes";
import { Root } from "./root";
import "./styles.css";
import { setFavicon } from "./utils/utils";

if (SENTRY_DSN) {
  Sentry.init({ dsn: SENTRY_DSN });
}

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <div>Not Found</div>,
    children: [
      {
        index: true,
        element: <Navigate to={"login"} />,
      },
      {
        path: "login",
        element: <Outlet />,
        children: loginRoutes,
      },
      {
        path: "orders",
        element: <Outlet />,
        children: orderRoutes,
      },
      {
        path: "returns",
        element: <Outlet />,
        children: returnRoutes,
      },
    ],
  },
]);

setFavicon();
const root = createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
